import CookieUtils from "../../lib/cookie-utils";

export function isLoggedIn(): boolean {
  return CookieUtils.getCookie('isLoggedIn') === 'true';
}
